
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 208.173 148.797","height":"562.381","width":"786.797","preserveAspectRatio":"xMaxYMax meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M208.173 0H60.32L0 148.797h160.17z","fill":"#041e42"}}),_c('text',{attrs:{"y":"219.737","x":"51.265","font-size":"11.113","font-family":"Helvetica","fill":"#fff","stroke-width":".265","transform":"translate(0 -148.198)"}},[_c('tspan',{attrs:{"x":"51.265","y":"219.737"}},[_v('Virtual')])]),_c('text',{attrs:{"y":"244.343","x":"51.265","font-size":"22.225","font-family":"Helvetica","fill":"#fff","stroke-width":".265","transform":"translate(0 -148.198)"}},[_c('tspan',{attrs:{"x":"51.265","y":"244.343"}},[_v('Open Days')])])])
          )
        }
      }
    